import { t } from "@lingui/macro";
import { LinearGradient } from "expo-linear-gradient";

import { BlockIcon } from "@whoosh/design-system/src/components/icons_v2/general";
import {
  Box,
  Text,
  VStack,
} from "@whoosh/design-system/src/components/primitive";

export const NoAvailableBookingTimes = () => {
  return (
    <VStack pt={20} gap={4}>
      <Box justifyContent={"center"} alignItems={"center"} borderRadius={"6"}>
        <LinearGradient
          style={{
            justifyContent: "center",
            alignItems: "center",
            padding: 12,
            borderRadius: 100,
          }}
          colors={["#F7F7F7", "#E7E7E7"]}
        >
          <BlockIcon />
        </LinearGradient>
      </Box>
      <Text variant="mainSmallMedium" color="text-primary" textAlign={"center"}>
        {t`There are no available booking times
        for your search criteria.`}
      </Text>
    </VStack>
  );
};
